module.exports = __webpack_public_path__ + "static/favicon-32x32-32de4005df57697e42d25f7433b0d6c0.png";